export default __webpack_public_path__ + "static/media/engine-yard.83f5dd50.svg";